import { getApolloClient } from '../lib/getApolloClient';
import { create } from 'zustand';
import { GET_AI_RESPONSE } from './ai.gql';
import { AiPromptType } from '../generated/gql-types';

interface AiState {
  jobTitle: string | null;
  jobDescription: string | null;
  isLoading: boolean;
  error: string | null;
  fetchAiResponse: (
    prompt: AiPromptType,
    args: FetchAiArgs,
  ) => Promise<string | null>;
}

interface FetchAiArgs {
  classification: string;
  startTime: string;
  clientName: string;
  address: string;
}

export const useAiStore = create<AiState>((set) => ({
  jobTitle: null,
  jobDescription: null,
  isLoading: false,
  error: null,
  fetchAiResponse: async (
    prompt: AiPromptType,
    args: FetchAiArgs,
  ): Promise<string | null> => {
    set({ isLoading: true, error: null });
    try {
      const { data } = await getApolloClient().query({
        query: GET_AI_RESPONSE,
        variables: { prompt, args },
      });
      if (prompt === AiPromptType.SuggestJobDescription) {
        set({
          jobDescription: data?.getAiResponse,
          isLoading: false,
        });
      } else {
        set({ jobTitle: data?.getAiResponse, isLoading: false });
      }
      return data?.getAiResponse;
    } catch (error) {
      console.log('error:', error);
      set({
        error:
          error instanceof Error ? error.message : 'An unknown error occurred',
        isLoading: false,
      });
      return null;
    }
  },
}));
